import React, { useState } from 'react';
import { Image, Pressable, Text, View } from 'react-native';
import { showError } from '../../toast';
import * as ImagePicker from 'expo-image-picker';
import { api, API_URL, UTILITY_LABELS } from '../../api';
import { Button, Card, COLORS, Input, Label, Muted, Screen, Title } from '../../ui';
import { compressAndUploadPhoto } from '../../photo-picker';
import { t } from '../../i18n';

export default function AddBillScreen({ route, navigation }: any) {
  const { apartmentId } = route.params;
  const now = new Date();
  const [type, setType] = useState('ELECTRICITY');
  const [amount, setAmount] = useState('');
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [year, setYear] = useState(String(now.getFullYear()));
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const pickInvoice = async () => {
    const result = await ImagePicker.launchImageLibraryAsync({ mediaTypes: ['images'], quality: 0.7 });
    if (result.canceled || !result.assets[0]) return;
    try {
      setPhotoUrl(await compressAndUploadPhoto(result.assets[0]));
    } catch (e: any) {
      showError(e.message);
    }
  };

  const submit = async () => {
    setLoading(true);
    try {
      await api(`/apartments/${apartmentId}/bills`, {
        body: {
          type,
          amountCents: Math.round(Number(amount.replace(',', '.')) * 100),
          periodMonth: Number(month),
          periodYear: Number(year),
          ...(photoUrl ? { invoicePhotoUrl: photoUrl } : {}),
        },
      });
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Нова сметка')}</Title>
      <Card>
        <Label>{t('Вид')}</Label>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
          {Object.entries(UTILITY_LABELS).map(([key, label]) => (
            <Pressable
              key={key}
              onPress={() => setType(key)}
              style={{
                paddingHorizontal: 12,
                paddingVertical: 8,
                borderRadius: 8,
                backgroundColor: type === key ? COLORS.primary : COLORS.bg,
                borderWidth: 1,
                borderColor: type === key ? COLORS.primary : COLORS.border,
              }}
            >
              <Text style={{ color: type === key ? '#fff' : COLORS.text }}>{t(label)}</Text>
            </Pressable>
          ))}
        </View>
        <Label>{t('Сума (€)')}</Label>
        <Input value={amount} onChangeText={setAmount} keyboardType="decimal-pad" placeholder="35.50" />
        <View style={{ flexDirection: 'row', gap: 8 }}>
          <View style={{ flex: 1 }}>
            <Label>{t('Месец')}</Label>
            <Input value={month} onChangeText={setMonth} keyboardType="number-pad" />
          </View>
          <View style={{ flex: 1 }}>
            <Label>{t('Година')}</Label>
            <Input value={year} onChangeText={setYear} keyboardType="number-pad" />
          </View>
        </View>

        <Label>{t('Снимка на фактурата')}</Label>
        {photoUrl && <Image source={{ uri: `${API_URL}${photoUrl}` }} style={{ width: 120, height: 160, borderRadius: 8, marginBottom: 8 }} />}
        <Button title={photoUrl ? t('Смени снимката') : t('+ Снимка на фактурата')} variant="secondary" onPress={pickInvoice} />
        <Muted>{t('Наемателят получава известие веднага след запазване.')}</Muted>

        <Button title={t('Запази сметката')} onPress={submit} disabled={!amount} loading={loading} />
      </Card>
    </Screen>
  );
}
